import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Base from './base'
import { Flex } from '@chakra-ui/react'

const CanvaCallback = () => {
  const { circleCode } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    navigate(`/event/${circleCode}/edit?source=canva`, {
      replace: true
    })
  }, [circleCode, navigate])

  return (
    <Base hideBg={true} bottomBar={false} allowFullHeight={true}>
      <Flex flex="1" align="center" justify="center"></Flex>
    </Base>
  )
}

export default CanvaCallback
